module.exports = __webpack_public_path__ + "img/about_logo_08.73d8480c.png";